import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

const requestKey = new HttpContextToken<string | null>(() => null);

/** The mutable request context retains the same key across RxJS/network retries. */
export const financialIdempotencyInterceptor: HttpInterceptorFn = (request, next) => {
  const path = request.url.startsWith(environment.baseUrl) ? request.url.slice(environment.baseUrl.length) : '';
  const financial = /^\/(stickers|parking-coupon-entries|parking-sessions|off-on-loading(?:-sessions|-transactions)?|defaulters|crcs\/\d+\/reconciliation|councils\/\d+\/(?:settlements|settlement-drafts)|financial-adjustments|financial-checkouts|loading-checkout)(\/|$)/.test(path);
  if (!financial || !['POST', 'PUT', 'PATCH', 'DELETE'].includes(request.method) || request.headers.has('Idempotency-Key')) return next(request);
  const key = request.context.get(requestKey) ?? crypto.randomUUID();
  request.context.set(requestKey, key);
  return next(request.clone({ setHeaders: { 'Idempotency-Key': key } }));
};
